/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trackingtable_Emptystate_Uploadprefix2Inputs */

const en_trackingtable_emptystate_uploadprefix2 = /** @type {(inputs: Trackingtable_Emptystate_Uploadprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Trackingtable_Emptystate_Uploadprefix2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const trackingtable_emptystate_uploadprefix2 = /** @type {((inputs?: Trackingtable_Emptystate_Uploadprefix2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trackingtable_Emptystate_Uploadprefix2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_trackingtable_emptystate_uploadprefix2(inputs)
});
export { trackingtable_emptystate_uploadprefix2 as "trackingtable_emptyState_uploadPrefix" }